import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LosAngelesPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does app development cost in Los Angeles?",
    answer: `<p>The mobile app development cost in Los Angeles can range from $25,000 to $500,000 or more. It depends on various factors like app complexity, design, third-party integrations, and development team size and location.</p>`,
  },
  {
    question:
      "How long does it take to complete a mobile app development project?",
    answer: ` <p>It takes about 4 to 6 months to complete a mobile app development project of average complexity.</p>
        <p>Other than that, here are the details according to different complexities:</p>
        <ul>
        <li>Simple App Development: 2 - 4 months</li>
        <li>Average App Development: 4 - 6 months</li>
        <li>Complex App Development: 9+ months</li>
    </ul>`,
  },
  {
    question:
      "Why should we hire you as a mobile app development company for our project?",
    answer: `<p>You should hire us for your project because of our proven expertise, track record of success, and commitment to tailored solutions.We offer cutting-edge mobile solutions timely with 24/7 ongoing support, and competitive pricing, ensuring your project's success.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{LosAngelesPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
